import { useParams, useRouter } from 'next/navigation';
import { COUNTRY_KEYS, DEFAULT_COUNTRY, getLocalizationInfo } from 'project.config';
import { useEffect, useState } from 'react';
import usePath from './usePath';
import { Market } from 'components/gruenland/organisms/market-button/MarketButton';

const useMarket = () => {
  const [markets, setMarkets] = useState<Market[]>([]);
  const [market, setMarket] = useState<Market>();
  const router = useRouter();

  const { path } = usePath();

  const { locale } = useParams();
  const { country, language } = getLocalizationInfo(locale);

  const handleMarket = (market: Market) => {
    setMarket(market);

    router.push(`/${market.countryCode.toLowerCase()}-${language.slice(0, 2)}${path}`);
  };

  useEffect(() => {
    const initialMarkets: Market[] = COUNTRY_KEYS.map((x) => {
      const { country } = getLocalizationInfo(`${x}-${language.slice(0, 2)}`);

      return {
        countryCode: country.countryCode,
        currencyCode: country.currencyCode,
        currency: country.currency,
        region: country.countryName,
      };
    });

    if (!initialMarkets) return;

    setMarkets(initialMarkets);

    let initialMarket = initialMarkets.find((market) => market.countryCode === country.countryCode);
    if (!initialMarket) {
      initialMarket = initialMarkets.find((market) => market.countryCode.toLowerCase() === DEFAULT_COUNTRY);
    }

    setMarket(initialMarket);
  }, [country.countryCode, language]);

  return { market, markets, handleMarket };
};

export default useMarket;
